import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {Row} from 'reactstrap';
import gaParams from '../../../utilities/analytics/constants';
import {gaEvent} from '../../../utilities/analytics/tracking';
import images from './images/images';

import Config from '../../../Config';
export default function selfCareActions(props) {
  console.log(props);
  const context = props.context;
  function Action(img, text, linkTo, isActionAllowed) {
    return (
      <>
        {linkTo ? (
          <div className='box-col'>
            <div className='box' onClick={() => Redirect(linkTo, text, isActionAllowed)}>
              <Image className='img' alt='action' src={img} />
              <div className='txt'>{text}</div>
            </div>
          </div>
        ) : null}
      </>
    );
  }

  function validURL(str) {
    var pattern = new RegExp(
      '^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$',
      'i',
    ); // fragment locator
    return !!pattern.test(str);
  }

  async function handleURL(url, context) {
    if (validURL(url)) {
      let win = window.open(url, '_blank');
      win.focus();
    } else {
      let content = await context.loadContentByPath(url);
      context.navigateTo(content);
    }
  }

  function reportGA(reportActionName) {
    gaEvent(
      gaParams.BUSINESS_PORTAL_CLICK_ON_ACTION_BOX.category,
      gaParams.BUSINESS_PORTAL_CLICK_ON_ACTION_BOX.eventType,
      reportActionName,
    );
  }

  const Redirect = (linkTo, reportActionName, isActionAllowed) => {
    reportGA(reportActionName);
    if (!isActionAllowed) {
      props.setIsShowPopup(true);
    } else {
      handleURL(linkTo, props.context);
    }
  };

  const actionList = [
    {
      img: images.debtPaymentPurple,
      title: 'עדכון אמצעי תשלום',
      url: props.updatePaymentUrl,
      isAllowed: !props.isServiceManager && props.allowedScActions,
    },
    {
      img: images.creditCardPurple,
      title: 'תשלום חוב',
      url: props.debtPaymentUrl,
      isAllowed: !props.isServiceManager && props.allowedScActions,
    },
    {
      img: images.invoicesPurple,
      title: 'צפייה בחשבוניות',
      url: props.watchInvoicesUrl,
      isAllowed: !props.isServiceManager && props.allowedScActions,
    },
    {
      img: images.abroadBusinessIndividual,
      title: `${window.Config.brand_Name_HE} חו"ל`,
      url: props.watchAbroadIndividualUrl,
      isAllowed: !props.isServiceManager && props.allowedCellular,
    },
    {
      img: images.personalInfo,
      title: ' פרטי מנוי',
      url: props.clientInformationUrl,
      isAllowed: !props.isServiceManager && props.allowedCellular,
    },
    {img: images.changeSim, title: 'החלפת SIM/ESIM', url: props.simChangeUrl, isAllowed: !props.isServiceManager && props.allowedCellular},
    {img: images.dataUsage, title: 'כמה גלשתי', url: props.dataUsageUrl, isAllowed: !props.isServiceManager && props.allowedCellular},
    {
      img: images.suspentAccount,
      title: 'חסימה/פתיחה של מנוי',
      url: props.suspendAccountUrl,
      isAllowed: !props.isServiceManager && props.allowedCellular,
    },
    {
      img: images.deviceRepair,
      title: 'תאום שליחות מכשיר לתיקון',
      url: props.imeiDeviceRepairUrl,
      isAllowed: !props.isServiceManager && props.allowedCellular,
    },
    {img: images.ccrIcon, title: 'דוח Ccr', url: props.ccrReportUrl, isAllowed: !props.isServiceManager && props.allowedCellular},
    {
      img: images.uploadUserLIstIcon,
      title: 'טעינת פרטי עובדים',
      url: props.uploadUsersListUrl,
      isAllowed: !props.isServiceManager && props.allowedUploadOrgUsersList,
    },
    {
      img: images.businessReports,
      title: 'דוחות עסקיים',
      url: props.businessReportsUrl,
      isAllowed: !props.isServiceManager && props.allowedBusinessReports,
    },
    {
      img: images.transferBusinessAccount,
      title: 'ניוד והפעלת קו חדש',
      url: props.transferBusinessAccountUrl,
      isAllowed: !props.isServiceManager && props.allowedCellular,
    },
    {img: images.retriveQRCode, title: 'שליחת QR קוד להפעלת ESIM', url: props.qrRetriveUrl, isAllowed: !props.isServiceManager && props.allowedCellular},
    {img: images.ownershipTransfer, title: 'העברת בעלות', url: props.ownershipTransferUrl, isAllowed: props.allowedCellular},
    {img: images.transferBusinessAccount, title: 'מערכת פניות', url: props.businessWorkOrderSystemUrl, isAllowed: props.allowedCellular},
    {img: images.reportManagement, title: 'היסטוריית פעולות באתר', url: props.dwhSystemUrl, isAllowed: props.allowedCellular},
  ];

  return (
    <>
      <Row className='self-care-row-header'>
        <h4 className='header'>
          {window.Config.brand_Name_HE} בשירות <strong>עצמי</strong>
        </h4>
      </Row>
      <Row className='self-care-action-row'>
        <div className='border'></div>
        {actionList.map((act) => {
          return Action(act.img, act.title, act.url, act.isAllowed);
        })}
      </Row>
    </>
  );
}
